import { useEffect, useState, useContext } from "react";
import fetchContext from "../../contexts/fetch";

const useFlowStatus = (flowId) => {
  const [isPublished, setIsPublished] = useState(undefined);
  const [isLoading, setIsLoading] = useState(undefined);
  const [fetchState] = useContext(fetchContext);

  useEffect(() => {
    if (fetchState.loadingFlowStatusApi) {
      setIsLoading(true);
      setIsPublished(false);
    } else if (
      !fetchState.loadingFlowStatusApi &&
      fetchState.lastCheckedFlowStatus
    ) {
      setIsLoading(false);
      if (fetchState.lastCheckedFlowStatus.id === flowId) {
        setIsPublished(fetchState.lastCheckedFlowStatus.isPublished);
      }
    }
  }, [fetchState.lastCheckedFlowStatus, fetchState.loadingFlowStatusApi]);

  return { isPublished, isLoading };
};

export default useFlowStatus;
